module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-switcher"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css"
    }
  }), _vm._v(" "), (_vm.type === 'dropdown') ? _c('div', {
    staticClass: "component dropdown"
  }, [(_vm.showTitle) ? _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Select your country")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('Dropdown', {
    attrs: {
      "options": _vm.countries,
      "validated": _vm.selectedCountry && _vm.selectedCountry.value,
      "value": _vm.selectedCountry ? _vm.selectedCountry.value : null,
      "label": _vm.label,
      "with-background": false,
      "bold-label": true,
      "type": "cleanlarge",
      "allow-empty": false,
      "combo": false
    },
    on: {
      "changed": _vm.changedCountry
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a423ec4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/CountrySwitcherNormal.vue
// module id = 925
// module chunks = 0